import { render, staticRenderFns } from "./InterestCategoryAdd.vue?vue&type=template&id=09b47b98"
import script from "./InterestCategoryAdd.vue?vue&type=script&lang=js"
export * from "./InterestCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports